import React, { Fragment } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Form, Input, Select, Row, Col, Radio, Button, Divider } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { useAddressGuarantorAutoComplete } from '../../../../../../../../../helpers/form/fetch-hook';
import InputBaht from '../../../../../../../common/InputBaht';
import styles from '../../../../../../application.module.scss';
import componentValues from '../../../../../../../../../services/utilities/ComponentValue';
import { getValidator } from '../../../../../../../../../helpers/validator';

interface Props {
  form: FormInstance;
  index: number;
}
const Address: React.FC<Props> = ({ form, index }) => {
  const intl = useIntl();
  const { setFieldsValue, getFieldValue, setFields } = form;
  const [
    setAddressesFromSearchResult,
    renderFilteredAddresses,
    setSelectedAddress,
  ] = useAddressGuarantorAutoComplete();
  function copyFromCurrent() {
    const current = {
      address: getFieldValue(['guarantors', index, 'addressInfo', 'current', 'address']),
      subDistrict: getFieldValue(['guarantors', index, 'addressInfo', 'current', 'subDistrict']),
      district: getFieldValue(['guarantors', index, 'addressInfo', 'current', 'district']),
      province: getFieldValue(['guarantors', index, 'addressInfo', 'current', 'province']),
      postCode: getFieldValue(['guarantors', index, 'addressInfo', 'current', 'postCode']),
      phoneNo: getFieldValue(['guarantors', index, 'addressInfo', 'current', 'phoneNo']),
      phoneNoExt: getFieldValue(['guarantors', index, 'addressInfo', 'current', 'phoneNoExt']),
    };
    setFields([
      {
        name: ['guarantors', index, 'addressInfo', 'permanent', 'address'],
        value: current.address,
      },
    ]);
    setFields([
      {
        name: ['guarantors', index, 'addressInfo', 'permanent', 'subDistrict'],
        value: current.subDistrict,
      },
    ]);
    setFields([
      {
        name: ['guarantors', index, 'addressInfo', 'permanent', 'district'],
        value: current.district,
      },
    ]);
    setFields([
      {
        name: ['guarantors', index, 'addressInfo', 'permanent', 'province'],
        value: current.province,
      },
    ]);
    setFields([
      {
        name: ['guarantors', index, 'addressInfo', 'permanent', 'postCode'],
        value: current.postCode,
      },
    ]);
    setFields([
      {
        name: ['guarantors', index, 'addressInfo', 'permanent', 'phoneNo'],
        value: current.phoneNo,
      },
    ]);
    setFields([
      {
        name: ['guarantors', index, 'addressInfo', 'permanent', 'phoneNoExt'],
        value: current.phoneNoExt,
      },
    ]);
  }
  return (
    <Fragment>
      <div id="currentAddress" className={styles.header}>
        <strong className={styles.title}>
          <FormattedMessage id="addressInfo.current" />
        </strong>
        <Form.Item
          label={<FormattedMessage id="address" />}
          name={['guarantors', index, 'addressInfo', 'current', 'address']}
        >
          <Input />
        </Form.Item>
        <Row gutter={componentValues.gutterValue}>
          <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
            <Form.Item
              label={<FormattedMessage id="subDistrict" />}
              name={['guarantors', index, 'addressInfo', 'current', 'subDistrict']}
            >
              <Select
                showSearch
                style={{ width: '100%' }}
                onChange={(value: string) =>
                  setSelectedAddress(value, getFieldValue, setFieldsValue, setFields, index, [
                    'guarantors',
                    `${index}`,
                    'addressInfo',
                    'current',
                  ])
                }
                onSearch={(value: string) => {
                  setAddressesFromSearchResult(value, 'subDistrict');
                }}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                notFoundContent={null}
              >
                {renderFilteredAddresses()}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
            <Form.Item
              label={<FormattedMessage id="district" />}
              name={['guarantors', index, 'addressInfo', 'current', 'district']}
            >
              <Select
                showSearch
                style={{ width: '100%' }}
                onChange={(value: string) =>
                  setSelectedAddress(value, getFieldValue, setFieldsValue, setFields, index, [
                    'guarantors',
                    `${index}`,
                    'addressInfo',
                    'current',
                  ])
                }
                onSearch={(value: string) => {
                  setAddressesFromSearchResult(value, 'district');
                }}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                notFoundContent={null}
              >
                {renderFilteredAddresses()}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
            <Form.Item
              label={<FormattedMessage id="province" />}
              name={['guarantors', index, 'addressInfo', 'current', 'province']}
            >
              <Select
                showSearch
                style={{ width: '100%' }}
                onChange={(value: string) =>
                  setSelectedAddress(value, getFieldValue, setFieldsValue, setFields, index, [
                    'guarantors',
                    `${index}`,
                    'addressInfo',
                    'current',
                  ])
                }
                onSearch={(value: string) => {
                  setAddressesFromSearchResult(value, 'province');
                }}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                notFoundContent={null}
              >
                {renderFilteredAddresses()}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
            <Form.Item
              label={<FormattedMessage id="postCode" />}
              name={['guarantors', index, 'addressInfo', 'current', 'postCode']}
            >
              <Select
                showSearch
                style={{ width: '100%' }}
                onChange={(value: string) =>
                  setSelectedAddress(value, getFieldValue, setFieldsValue, setFields, index, [
                    'guarantors',
                    `${index}`,
                    'addressInfo',
                    'current',
                  ])
                }
                onSearch={(value: string) => {
                  setAddressesFromSearchResult(value, 'postCode');
                }}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                notFoundContent={null}
              >
                {renderFilteredAddresses()}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <FormattedMessage id="yearOfStay" />
        </Row>
        <Row gutter={componentValues.gutterValue}>
          <Col xs={{ span: 24 }} sm={{ span: 4 }}>
            <Form.Item name={['guarantors', index, 'addressInfo', 'current', 'stayYear']}>
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 4 }}>
            <Form.Item name={['guarantors', index, 'addressInfo', 'current', 'stayMonth']}>
              <Input type="number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={componentValues.gutterValue}>
          <Col xs={{ span: 24 }} sm={{ span: 4 }}>
            <Form.Item
              label={<FormattedMessage id="mobileNo" />}
              name={['guarantors', index, 'mobileNo']}
              rules={[{ validator: getValidator(intl, 'telNo') }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 8 }}>
            <Form.Item
              label={<FormattedMessage id="mobilePackage" />}
              name={['guarantors', index, 'personalInfo', 'mobilePackage']}
            >
              <Radio.Group buttonStyle="solid">
                <Radio.Button value="prepaid">
                  <FormattedMessage id="prepaid" />
                </Radio.Button>
                <Radio.Button value="postpaid">
                  <FormattedMessage id="postpaid" />
                </Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={componentValues.gutterValue}>
          <Col sm={{ span: 6 }}>
            <Form.Item
              label={<FormattedMessage id="phoneNo" />}
              name={['guarantors', index, 'addressInfo', 'current', 'phoneNo']}
              rules={[{ validator: getValidator(intl, 'telNo') }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col sm={{ span: 6 }}>
            <Form.Item
              label={<FormattedMessage id="phoneNoExt" />}
              name={['guarantors', index, 'addressInfo', 'current', 'phoneNoExt']}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col sm={{ span: 6 }}>
            <Form.Item
              label={<FormattedMessage id="contactTime" />}
              name={['guarantors', index, 'personalInfo', 'contactTime']}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label={<FormattedMessage id="residentType" />}
          name={['guarantors', index, 'addressInfo', 'current', 'residentType']}
        >
          <Radio.Group buttonStyle="solid">
            <Radio.Button value="house">
              <FormattedMessage id="residentType.house" />
            </Radio.Button>
            <Radio.Button value="townHouse">
              <FormattedMessage id="residentType.townHouse" />
            </Radio.Button>
            <Radio.Button value="condo">
              <FormattedMessage id="residentType.condo" />
            </Radio.Button>
            <Radio.Button value="apartment">
              <FormattedMessage id="residentType.apartment" />
            </Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label={<FormattedMessage id="residentOwner" />}
          name={['guarantors', index, 'addressInfo', 'current', 'residentOwner']}
        >
          <Radio.Group buttonStyle="solid">
            <Radio.Button value="own">
              <FormattedMessage id="residentOwner.own" />
            </Radio.Button>
            <Radio.Button value="family">
              <FormattedMessage id="residentOwner.family" />
            </Radio.Button>
            <Radio.Button value="welfare">
              <FormattedMessage id="residentOwner.welfare" />
            </Radio.Button>
            <Radio.Button value="rent">
              <FormattedMessage id="residentOwner.rent" />
            </Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label={<FormattedMessage id="rent" />}
          name={['guarantors', index, 'addressInfo', 'current', 'rent']}
        >
          <InputBaht />
        </Form.Item>
      </div>
      <Divider dashed />
      <div id="permanentAddress" className={styles.header}>
        <strong className={styles.title}>
          <FormattedMessage id="addressInfo.permanent" />
          <Button style={{ marginLeft: '10px' }} type="primary" onClick={copyFromCurrent}>
            <FormattedMessage id="useCurrentAddress" />
          </Button>
        </strong>
        <Form.Item
          label={<FormattedMessage id="address" />}
          name={['guarantors', index, 'addressInfo', 'permanent', 'address']}
        >
          <Input />
        </Form.Item>
        <Row gutter={componentValues.gutterValue}>
          <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
            <Form.Item
              label={<FormattedMessage id="subDistrict" />}
              name={['guarantors', index, 'addressInfo', 'permanent', 'subDistrict']}
            >
              <Select
                showSearch
                style={{ width: '100%' }}
                onChange={(value: string) =>
                  setSelectedAddress(value, getFieldValue, setFieldsValue, setFields, index, [
                    'guarantors',
                    `${index}`,
                    'addressInfo',
                    'permanent',
                  ])
                }
                onSearch={(value: string) => {
                  setAddressesFromSearchResult(value, 'subDistrict');
                }}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                notFoundContent={null}
              >
                {renderFilteredAddresses()}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
            <Form.Item
              label={<FormattedMessage id="district" />}
              name={['guarantors', index, 'addressInfo', 'permanent', 'district']}
            >
              <Select
                showSearch
                style={{ width: '100%' }}
                onChange={(value: string) =>
                  setSelectedAddress(value, getFieldValue, setFieldsValue, setFields, index, [
                    'guarantors',
                    `${index}`,
                    'addressInfo',
                    'permanent',
                  ])
                }
                onSearch={(value: string) => {
                  setAddressesFromSearchResult(value, 'district');
                }}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                notFoundContent={null}
              >
                {renderFilteredAddresses()}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
            <Form.Item
              label={<FormattedMessage id="province" />}
              name={['guarantors', index, 'addressInfo', 'permanent', 'province']}
            >
              <Select
                showSearch
                style={{ width: '100%' }}
                onChange={(value: string) =>
                  setSelectedAddress(value, getFieldValue, setFieldsValue, setFields, index, [
                    'guarantors',
                    `${index}`,
                    'addressInfo',
                    'permanent',
                  ])
                }
                onSearch={(value: string) => {
                  setAddressesFromSearchResult(value, 'province');
                }}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                notFoundContent={null}
              >
                {renderFilteredAddresses()}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }}>
            <Form.Item
              label={<FormattedMessage id="postCode" />}
              name={['guarantors', index, 'addressInfo', 'permanent', 'postCode']}
            >
              <Select
                showSearch
                style={{ width: '100%' }}
                onChange={(value: string) =>
                  setSelectedAddress(value, getFieldValue, setFieldsValue, setFields, index, [
                    'guarantors',
                    `${index}`,
                    'addressInfo',
                    'permanent',
                  ])
                }
                onSearch={(value: string) => {
                  setAddressesFromSearchResult(value, 'postCode');
                }}
                defaultActiveFirstOption={false}
                showArrow={false}
                filterOption={false}
                notFoundContent={null}
              >
                {renderFilteredAddresses()}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={componentValues.gutterValue}>
          <Col sm={{ span: 6 }}>
            <Form.Item
              label={<FormattedMessage id="phoneNo" />}
              name={['guarantors', index, 'addressInfo', 'permanent', 'phoneNo']}
              rules={[{ validator: getValidator(intl, 'telNo') }]}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
          <Col sm={{ span: 6 }}>
            <Form.Item
              label={<FormattedMessage id="phoneNoExt" />}
              name={['guarantors', index, 'addressInfo', 'permanent', 'phoneNoExt']}
            >
              <Input type="number" />
            </Form.Item>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
};

export default Address;
